import React from 'react';
import Header from '../../components/header';
import Dashboard from './Dashboard';
import './Dashboard.scss';

const CustomDashboardPage = () => (
    <div className="custom-dashboard-page">
        <Header title="Custom Dashboard" />
        <Dashboard persistMode="api" />
    </div>
);

export default CustomDashboardPage;
